import { FC, ReactNode } from 'react';

import { useIsPresignMode } from '@/features/presignAuth';

import { LanguageSelector } from '../LanguageSelector/LanguageSelector';
import { LearningHub } from '../LearningHub/LearningHub';
import { ThemeSelector } from '../ThemeSelector/ThemeSelector';

type HeaderSettingsWrapperProps = {
  className?: string;
  isMobile?: boolean;
  isProtectedPages?: boolean;
  children?: ReactNode;
};

export const HeaderSettingsWrapper: FC<HeaderSettingsWrapperProps> = (
  props,
) => {
  const {
    className,
    isMobile = false,
    isProtectedPages = true,
    children,
  } = props;

  const isPresignMode = useIsPresignMode();

  if (isPresignMode) {
    return (
      <div className={className}>
        <LanguageSelector isMobile={isMobile} />
        <ThemeSelector isMobile={isMobile} />
      </div>
    );
  }

  return (
    <div className={className}>
      <LearningHub isMobile={isMobile} />
      <LanguageSelector isMobile={isMobile} />
      <ThemeSelector isMobile={isMobile} />
      {isProtectedPages && children}
    </div>
  );
};
